import React, { useState, useEffect } from "react";
import axios from "axios";

const InstallationPersonData = () => {
  const [servicePersons, setServicePersons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState("");
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState(null);
  const [selectedState, setSelectedState] = useState("");

  const states = [
    "Maharashtra",
    "Haryana",
    "Punjab",
    "Rajasthan",
    "Chhattisgarh",
  ];

  useEffect(() => {
    if (selectedState) {
      fetchServicePersons(selectedState);
    } else {
      setServicePersons([]);
      setSelectedPerson("");
    }
  }, [selectedState]);

  const fetchServicePersons = async (state) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API_URL}/service-team/state-wise-service-persons?state=${state}`,

      );

      if (response.data.success) {
        setServicePersons(response?.data?.data);
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (err) {
      setError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedPerson) {
      fetchDashboardData(selectedPerson);
    } else {
      setDashboardData(null);
    }
  }, [selectedPerson]);

  const fetchDashboardData = async (empId) => {
    setDashboardLoading(true);
    setDashboardError(null);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API_URL}/service-team/show-emp-dashboard?empId=${empId}`,
      );

      if (response?.data?.success) {
        setDashboardData(response?.data?.data);
      } else {
        throw new Error(response?.data?.message);
      }
    } catch (err) {
      setDashboardError(err?.message);
      setDashboardData(null);
    } finally {
      setDashboardLoading(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Installation Material
        </h2>
      </div>

      {/* Selection Section */}
      <div className="bg-white shadow-md rounded-xl p-6 mb-3">
        <div className="grid md:grid-cols-2 gap-6">
          {/* State */}
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-2">
              Select State
            </label>
            <select
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
              className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
            >
              <option value="">Select State</option>
              {states.map((state, index) => (
                <option key={index} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          {/* Service Person */}
          {selectedState && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-2">
                Select Installation Person
              </label>
              <select
                value={selectedPerson}
                onChange={(e) => setSelectedPerson(e.target.value)}
                disabled={loading}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none disabled:bg-gray-100"
              >
                <option value="">Select Person</option>

                {servicePersons.map((person) => (
                  <option key={person._id} value={person._id}>
                    {person.name}
                  </option>
                ))}
              </select>

              {loading && (
                <p className="text-sm text-gray-500 mt-1">Loading persons...</p>
              )}
            </div>
          )}
        </div>

        {error && (
          <div className="mt-4 bg-red-50 text-red-600 p-3 rounded-lg border">
            {error}
          </div>
        )}
      </div>

      {/* Dashboard */}
      {dashboardLoading && (
        <div className="text-center py-10 text-gray-500">
          Loading dashboard data...
        </div>
      )}

      {dashboardError && (
        <div className="bg-red-50 text-red-600 p-3 rounded-lg border">
          {dashboardError}
        </div>
      )}

      {dashboardData && (
        <div className="bg-white shadow-md rounded-xl p-6">
          <h3 className="text-lg font-semibold text-gray-800 ">
            Assigned Items
          </h3>

          <div className="overflow-x-auto">
            <div className="max-h-[400px] overflow-y-auto border rounded-lg">
              <table className="min-w-full">
                <thead className="bg-gray-100 sticky top-0">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">
                      Item Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">
                      Quantity
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y">
                  {dashboardData?.itemsList?.length > 0 ? (
                    dashboardData.itemsList.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-6 py-3 text-sm">
                          {item.systemItemId?.itemName || "N/A"}
                        </td>

                        <td className="px-6 py-3 text-sm">{item.quantity}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center text-gray-500 py-6"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstallationPersonData;
